<template>
  <main role="main">
    <div class="container py-4" style="max-width:700px;">
      <h4 class="mb-4">{{ $t("configBackupPolicy") }}</h4>
      <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
      <b-form v-if="!isLoading && currentBackupPolicy" @keydown="formKeyDown" @submit.prevent="submitForm">

        <b-form-group label-for="input-cron-job-schedule" :description="$t('cronScheduleExplain')">
          <template v-slot:label>{{ $t("backupCronSchedule") }} <span class="text-danger">*</span></template>
          <b-form-input id="input-cron-job-schedule" type="text" required maxlength="255"
                        v-model="cronJobSchedule" name="cronJobSchedule"></b-form-input>
        </b-form-group>

        <b-form-group label-for="radio-enable-backup" :label="$t('activateBackupSchedule')">
          <b-form-radio-group id="radio-enable-backup" :options="enableBackupOptions"
                              v-model="enableBackup" name="enableBackup"></b-form-radio-group>
        </b-form-group>

        <b-form-group label-for="input-local-path">
          <template v-slot:label>{{ $t("backupLocalPath") }} <span class="text-danger">*</span></template>
          <b-form-input id="input-local-path" type="text" required maxlength="255"
                        v-model="localPath" name="localPath"></b-form-input>
        </b-form-group>

        <b-form-row>
          <b-form-group class="col-lg-4" label-for="radio-backup-source-code" :label="$t('backupSourceCode')">
            <b-form-radio-group id="radio-backup-source-code" :options="backupSourceCodeOptions"
                    v-model="backupSourceCode" name="backupSourceCode"></b-form-radio-group>
          </b-form-group>
          <b-form-group class="col-lg-4" label-for="radio-backup-db" :label="$t('backupDb')">
            <b-form-radio-group id="radio-backup-db" :options="backupDbOptions"
                    v-model="backupDb" name="backupDb"></b-form-radio-group>
          </b-form-group>
          <b-form-group class="col-lg-4" :label="$t('backupOptions')">
            <b-form-select required :options="backupOptionOptions" v-model="backupOption" />
          </b-form-group>
        </b-form-row>



        <b-form-row>
          <b-form-group class="col-lg-8" label-for="input-ftp-host">
            <template v-slot:label>FTP Host <span class="text-danger">*</span></template>
            <b-form-input id="input-ftp-host" type="text" required maxlength="255"
                          v-model="ftpHost" name="ftpHost"/>
          </b-form-group>
          <b-form-group class="col-lg-4" label-for="input-ftp-port">
            <template v-slot:label>FTP Port <span class="text-danger">*</span></template>
            <b-form-input id="input-ftp-port" type="number" required min="6" max="64"
                          v-model="ftpPort" name="ftpPort"></b-form-input>
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <b-form-group class="col-lg-6" label-for="input-ftp-user">
            <template v-slot:label>FTP User name <span class="text-danger">*</span></template>
            <b-form-input id="input-ftp-user" type="text" required maxlength="255"
                          v-model="ftpUser" name="ftpUser"/>
          </b-form-group>
          <b-form-group class="col-lg-6" label-for="input-ftp-password">
            <template v-slot:label>FTP Password <span class="text-danger">*</span></template>
            <b-form-input id="input-ftp-password" type="password" required minlength="6" maxlength="255"
                          v-model="ftpPassword" name="ftpPassword"></b-form-input>
          </b-form-group>
        </b-form-row>

        <b-form-group label-for="input-ftp-path">
          <template v-slot:label>FTP Path <span class="text-danger">*</span></template>
          <b-form-input id="input-ftp-path" type="text" required maxlength="255"
                        v-model="ftpPath" name="ftpPath"></b-form-input>
        </b-form-group>

        <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

        <div class="text-center pt-3">
          <b-button type="submit" variant="primary" style="width: 120px;"
                    :disabled="isSubmitting" @click="beforeSubmit">{{ $t("save") }}</b-button>
          <!-- <b-button type="button" variant="outline-primary" style="width: 120px; margin-left:5px;"
                     @click="onClickRunBackup">Sao lưu ngay</b-button> -->
        </div>

      </b-form>
    </div>
  </main>
</template>


<style lang="scss" scoped>

</style>


<script lang="ts">
  import {Component, Emit, Prop} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as backupPolicyService from "@/service/backupPolicyService";

  @Component
  export default class BackupPolicy extends BaseComponent {

    isLoading = true;

    currentBackupPolicy=null;

    cronJobSchedule = "";
    localPath="";
    ftpHost = "";
    ftpPort = 22;
    ftpUser="";
    ftpPassword="";
    ftpPath = "";

    backupSourceCodeOptions = [
      { value: true, text: this.$t("yes").toString() },
      { value: false, text: this.$t("no").toString() },
    ];
    backupSourceCode = true;

    backupDbOptions = [
      { value: true, text: this.$t("yes").toString() },
      { value: false, text: this.$t("no").toString() },
    ];
    backupDb = true;

    enableBackupOptions = [
      { value: true, text: this.$t("yes").toString() },
      { value: false, text: this.$t("no").toString() },
    ];
    enableBackup = true;

    backupOptionOptions = [
      { text: this.$t("storeLocal").toString(), value: 1 },
      { text: this.$t("storeViaFtp").toString(), value: 2 },
      { text: this.$t("storeBothLocalAndFtp").toString(), value: 3 },
    ];
    backupOption = 3;


    formErrorMsg = "";
    isSubmitting = false;

    // Emit decorators only
    @Emit("submitted") __submitted() {}

    mounted(){
      this.fetchBackupPolicy();
    }

    async fetchBackupPolicy(){
      try{
        this.isLoading = true;
        this.currentBackupPolicy = await backupPolicyService.get();
        Object.assign(this, this.currentBackupPolicy);

      } catch (e) {
        console.error(e);

      } finally {
        this.isLoading = false;
      }

    }

    formKeyDown(event) {
      return event.key !== 'Enter';
    }

    beforeSubmit(){
      const trimFields = ["cronJobSchedule", "ftpHost", "ftpUser","ftpPassword","ftpPath","localPath"];
      for (const field of trimFields) {
        this[field] = this[field].trim();
      }

    }

    async onClickRunBackup(){
      try{
        await backupPolicyService.run();
        this.toastSuccessDelay(this.$t("activeSuccessful").toString(), null, 0);
        this.fetchBackupPolicy();


      }catch(e){
        this.toastError(e);

      } finally {
      }
    }


    async submitForm(){
      try{
        this.isSubmitting = true;

        const body = {
          enableBackup: this.enableBackup,
          cronJobSchedule: this.cronJobSchedule,
          ftpHost: this.ftpHost,
          ftpPort: +this.ftpPort,
          ftpUser: this.ftpUser,
          ftpPassword: this.ftpPassword,
          ftpPath: this.ftpPath,
          localPath: this.localPath,
          backupSourceCode: this.backupSourceCode,
          backupDb: this.backupDb,
          backupOption: +this.backupOption,
        };
        await backupPolicyService.set(body);
        this.toastSuccessDelay(this.$t("saveSettingsSuccessful").toString(), null, 0);
        this.fetchBackupPolicy();


      }catch(e){
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
